import magnifiAPIInstance from "./apiInstance";

export const ruleExecutionAPIs = {
  getRuleExecutions: ({ entityId, payload }) =>
    magnifiAPIInstance.get(`/api/v3/entities/${entityId}/rule-executions`, payload),
};
